import { render, staticRenderFns } from "./TouchpointOverviewIconMagic.vue?vue&type=template&id=62148250&scoped=true&functional=true&"
import script from "./TouchpointOverviewIconMagic.vue?vue&type=script&lang=js&"
export * from "./TouchpointOverviewIconMagic.vue?vue&type=script&lang=js&"
import style0 from "../../../Style/touchpoint-overview-icon-magic.scss?vue&type=style&index=0&id=62148250&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  true,
  null,
  "62148250",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("n:\\Projects\\Werk\\MarketingDbNEW\\MarketingDb.Web.Zeiss\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('62148250')) {
      api.createRecord('62148250', component.options)
    } else {
      api.rerender('62148250', component.options)
    }
    module.hot.accept("./TouchpointOverviewIconMagic.vue?vue&type=template&id=62148250&scoped=true&functional=true&", function () {
      api.rerender('62148250', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "ScriptsV2/Core/Modules/JourneyBuilder/Components/Composer/TouchpointOverview/TouchpointOverviewIconMagic.vue"
export default component.exports